import { Routes, Route, BrowserRouter, useLocation } from "react-router-dom";
import RouteNames from "./RouteNames";
import Layout from "../components/Layout";
import PageTitleComponent from "../components/PageTitleComponent";
import ErrorPageComponent from "../components/ErrorPageComponent";
import PageErrorBoundary from "../components/PageErrorBoundary";

const PageRoutes = () => {
  const location = useLocation();

  return (
    <PageErrorBoundary key={location.pathname}>
      <Routes>
        {RouteNames.map((route) => (
          <Route
            key={route.name}
            path={route.name}
            element={
              <PageTitleComponent title={route.title}>
                {route.component}
              </PageTitleComponent>
            }
          />
        ))}
        <Route path="/eroare/:code" element={<ErrorPageComponent />} />
        <Route path="*" element={<ErrorPageComponent code="404" />} />
      </Routes>
    </PageErrorBoundary>
  );
};

const AppRouter = () => {
  return (
    <BrowserRouter>
      <Layout>
        <PageRoutes />
      </Layout>
    </BrowserRouter>
  );
};
export default AppRouter;
